const priceParser = price => (
  parseFloat(price)
    .toLocaleString('en-GB', {style: 'currency', currency: 'GBP'})
)

export default priceParser
